import React from 'react';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';
import { usePromotions } from './hooks';
import { ProfessionalPromotionPayouts } from './ProfessionalPromotionPayouts';

export const PromotionsTabScreen = () => {
  const { options, formValue, handleStatusChanged } = usePromotions();

  return (
    <>
      <TabViewContainer style={{ width: '50%' }} title="Best in Dental" variant="card">
        <div style={{ width: '50%', marginInline: 'auto' }}>
          <label htmlFor="status" style={{ width: '100%' }}>
            Contest Status
            <select
              id="status"
              className="custom-select custom-select-lg mb-3"
              style={{ marginTop: '5px' }}
              value={formValue}
              onChange={(e) => handleStatusChanged(e.target.value)}
            >
              {options.map(({ label, value }) => (
                <option className="dropdown-item" key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </TabViewContainer>

      <ProfessionalPromotionPayouts />
    </>
  );
};
